export default __webpack_public_path__ + "static/media/gallary.924b6cfd.png";